import ScrollMagic from 'scrollmagic';

// init controller
const controller = new ScrollMagic.Controller({});


if (document.querySelectorAll('header').length !== 0) {
// create a scene
  new ScrollMagic.Scene({
    triggerElement: 'header',
    triggerHook: '0.75',
  })
    .duration('100%')
    .setClassToggle('.scroll-indicator', 'scroll-indicator--visible')
    .addTo(controller);
}

